//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UiIcon from './UiIcon.vue';

export default {
  name: 'UiMenuOption',

  components: {
    UiIcon,
  },

  props: {
    type: String,
    label: String,
    href: String,
    target: String,
    icon: String,
    iconProps: {
      type: Object,
      default() {
        return {};
      },
    },
    secondaryText: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return {
        'is-divider': this.isDivider,
        'is-disabled': this.disabled,
        'is-anchor': this.isAnchor,
      };
    },

    isDivider() {
      return this.type === 'divider';
    },

    isAnchor() {
      return !this.isDivider && this.href !== undefined;
    },
  },
};

